/* eslint-disable */
import * as React from 'react'
import { useEffect, useRef, useState, useCallback } from 'react'
import UserMediaService from '../../../services/UserMediaService';
import Footer from '../../react/Footer/Footer';
import { useNavigate, useLocation } from 'react-router-dom';
import { DailyProvider, useCallObject, useLocalParticipant, useLocalSessionId, useAudioTrack } from '@daily-co/daily-react';
import { fixChromeEchoCancellationForAudioNode } from '../../../utils/audio';
import { createRoom, createOwnerMeetingToken } from '../../../services/RoomService';
import Preview from '../../react/Preview/Preview';
import BabylonScene from '../../babylon/Scene/BabylonScene';
import Scene from '../../r3f/Scene/Scene';
import { CallLocalMediaProvider } from '../context/CallLocalMediaContext';
import { generateCallOptions } from './CallOptions';
import HUDCallControls from '../HUD/CallControls/CallControls';
import { DEFAULT_ROOM_ID } from '../../../utils/constants';

interface CallViewProps {
  // roomId: string | undefined,
  renderer: 'R3F' | 'BabylonJS',
}

const CallView: React.FC<CallViewProps> = ({ renderer = 'R3F'}) => {
  const callObject = useCallObject({ shouldCreateInstance(){ return true } });

  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const roomId = searchParams.get('roomId');
  const token = searchParams.get('token');

  const [isPreview, setIsPreview] = useState(true);

  const joinRoom = async () => {
    if (!callObject) return;

    callObject.setBandwidth({
      trackConstraints: {
        width: 200,
        height: 200,
        frameRate: 30,
      },
    });

    if (!roomId) {
      const createRoomResponse = await createRoom();
      const newRoomId = createRoomResponse.name;
      const ownerMeetingToken = await createOwnerMeetingToken(newRoomId);
      navigate(`/${renderer === 'R3F' ? 'r3f' : 'room'}?roomId=${newRoomId}`, { replace: true });
      await callObject.preAuth(generateCallOptions(newRoomId, ownerMeetingToken.token));
      // await callObject.join(generateCallOptions(newRoomId));
    } else {
      navigate(`/${renderer === 'R3F' ? 'r3f' : 'room'}?roomId=${roomId}`, { replace: true });
      await callObject.preAuth(generateCallOptions(roomId, token));
      // await callObject.join(generateCallOptions(roomId));
    }

    const doesAudioEngineNeedLoopbackFix = navigator.userAgent.indexOf('Chrome') !== -1;
    if (doesAudioEngineNeedLoopbackFix) {
      fixChromeEchoCancellationForAudioNode(UserMediaService.getAudioContext());
    }
  }

  const cleanupRoom = useCallback(async () => {
    await callObject?.leave();
    await callObject?.destroy();
    UserMediaService.stopMediaTracks();
  }, [callObject]);

  useEffect(() => {
    if (!callObject) return;
    joinRoom();
    return () => {
      cleanupRoom();
    }
  }, [callObject]);

  const handleEnter = useCallback(() => {
    setIsPreview(false);
  }, [callObject]);

  return (
    <>
      {callObject && (
        <DailyProvider callObject={callObject}>
          <CallLocalMediaProvider>
            {isPreview ? (
              <Preview 
                onEnter={handleEnter}
              />
            ) : (
              <>
                {renderer === 'BabylonJS' ? <BabylonScene /> : <Scene />}
              </>
            )}
          </CallLocalMediaProvider>
        </DailyProvider>
      )}
    </>
  );  
}

export default CallView;